<template>

    <button
        v-bind="$attrs"
        @click="handleClick"
        :aria-label="'Toggle ' + props.type"
    >
        <slot></slot>
    </button>

</template>

<script setup>
import { computed } from "vue";
import usePublicStore from "@stores/publicStore";

const publicStore = usePublicStore();

const props = defineProps({
    // Determines which action to perform: "modal" or "sidebar"
    type: {
        type: String,
        default: "modal",
        validator: (value) => ["modal", "sidebar"].includes(value),
    },
    // Optional target override; if not provided, defaults are used
    target: {
        type: String,
        default: "",
    },
});

// If no target is provided, use "modal" for modal type or "sidebar" for sidebar type
const effectiveTarget = computed(
    () => props.target || (props.type === "modal" ? "modal" : "sidebar"),
);

const handleClick = () => {
    if (props.type === "modal") {

        publicStore.openModal(effectiveTarget.value);
    } else if (props.type === "sidebar") {
        publicStore.toggleSidebar(effectiveTarget.value);
    }
};
</script>
